<template>
  <v-row class="d-flex justify-center pb-100">
    <v-col cols="12">
      <section
        :id="model.name"
        class="about-area pt-50"
        v-for="(model, idx) in modelsAi"
        :key="idx"
      >
        <div class="container">
          <div
            class="row pt-6 px-2 justify-lg-space-around justify-xl-space-around justify-md-center justify-sm-center justify-xs-center align-center"
            :style="{
              backgroundColor: colors[idx % 2],
              borderRadius: '12px',
            }"
          >
            <!--            content-->
            <div
              :style="{
                order: idx % 2,
                paddingBottom: '50px',
              }"
              class="col-lg-7 detail-model"
            >
              <div
                class="about-content mt-50 wow fadeInLeftBig ma-auto"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <div class="section-title">
                  <div class="line"></div>
                  <h3 class="title-keyword" style="text-transform: capitalize">
                    {{ $t(model.name) }}
                  </h3>
                </div>
                <!-- section title -->
                <p class="text">
                  {{ $t(model.detail) }}
                </p>
                <h5 class="title-keyword">{{ $t("main_feature") }}</h5>
                <span
                  v-for="(feature, idxF) in $t(model.feature)"
                  :key="idxF"
                  style="margin-left: 12px"
                >
                  <v-icon color="green" left>{{ iConCheck }}</v-icon
                  >{{ feature }}
                </span>
                <h5 class="title-keyword mt-6 mb-6">
                  {{ $t("technical_framework") }}
                </h5>
                <div class="row justify-start align-end logo-framework">
                  <v-tooltip
                    bottom
                    v-for="(framework, idxImg) in model.techs"
                    :key="idxImg"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <a :href="framework.home" target="_blank">
                        <img v-bind="attrs" v-on="on" :src="framework.url" />
                      </a>
                    </template>
                    <span>{{ framework.name }}</span>
                  </v-tooltip>
                </div>
              </div>
              <!-- about content -->
            </div>
            <!--            image-->
            <div
              :style="{
                order: (idx + 1) % 2,
              }"
              class="col-lg-4 image-model"
            >
              <div
                class="model-image text-center mt-50 wow fadeInRightBig"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <img :src="model.image" alt="about" />
              </div>
              <!-- about image -->
            </div>
          </div>
        </div>
      </section>
    </v-col>
  </v-row>
</template>

<script>
import { mdiCheck } from "@mdi/js";

export default {
  name: "index.vue",
  data() {
    return {
      modelsAi: [
        {
          name: "cdn_title",
          image: "images/models/cdn.png",
          detail: "cdn_detail",
          feature: "cdn_feature",
          techs: [
            {
              url: "images/framework/openresty.png",
              name: "OpenResty",
              home: "https://openresty.org/",
            },
            {
              url: "images/framework/nginx.png",
              name: "Nginx",
              home: "https://github.com/deepinsight/insightface",
            },
          ],
        },
        {
          name: "transcoding_system_title",
          image: "images/models/transcode.png",
          detail: "transcoding_system_detail",
          feature: "transcoding_system_feature",
          techs: [
            {
              url: "images/framework/go.svg",
              name: "Go",
              home: "https://go.dev/",
            },
            {
              url: "images/framework/ffmpeg.webp",
              name: "FFmpeg",
              home: "https://ffmpeg.org/",
            },
            {
              url: "images/framework/k8s.png",
              name: "K8s",
              home: "https://kubernetes.io/",
            },
            {
              url: "images/framework/nvidia_logo.webp",
              name: "NVIDIA",
              home: "https://www.nvidia.com/download/index.aspx",
            },
          ],
        },
        {
          name: "celeb_title",
          image: "images/models/celeb-banner.webp",
          detail: "celeb_detail",
          feature: "celeb_feature",
          techs: [
            {
              url: "images/framework/pytorch-logo.webp",
              name: "Pytorch",
              home: "https://pytorch.org",
            },
            {
              url: "images/framework/insightface.webp",
              name: "InsightFace",
              home: "https://github.com/deepinsight/insightface",
            },
            {
              url: "images/framework/nvidia_logo.webp",
              name: "NVIDIA",
              home: "https://www.nvidia.com/download/index.aspx",
            },
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
          ],
        },
        {
          name: "emotion_title",
          image: "images/models/emotion-banner.webp",
          detail: "emotion_detail",
          feature: "emotion_feature",
          techs: [
            {
              url: "images/framework/pytorch-logo.webp",
              name: "Pytorch",
              home: "https://pytorch.org",
            },
            {
              url: "images/framework/insightface.webp",
              name: "InsightFace",
              home: "https://github.com/deepinsight/insightface",
            },
            {
              url: "images/framework/nvidia_logo.webp",
              name: "NVIDIA",
              home: "https://www.nvidia.com/download/index.aspx",
            },
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
          ],
        },
        {
          name: "action_title",
          image: "images/models/action-banner.webp",
          detail: "action_detail",
          feature: "action_feature",
          techs: [
            {
              url: "images/framework/pytorch-logo.webp",
              name: "Pytorch",
              home: "https://pytorch.org",
            },
            {
              url: "images/framework/tensort.webp",
              name: "TensorRT",
              home: "https://developer.nvidia.com/tensorrt",
            },
            {
              url: "images/framework/nvidia_logo.webp",
              name: "NVIDIA",
              home: "https://www.nvidia.com/download/index.aspx",
            },
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
          ],
        },
        {
          name: "scene_title",
          image: "images/models/scene-banner.webp",
          detail: "scene_detail",
          feature: "scene_feature",
          techs: [
            {
              url: "images/framework/pytorch-logo.webp",
              name: "Pytorch",
              home: "https://pytorch.org",
            },
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
          ],
        },
        {
          name: "cmn_obj_title",
          image: "images/models/cmn-obj-banner.webp",
          detail: "cmn_obj_detail",
          feature: "cmn_obj_feature",
          techs: [
            {
              url: "images/framework/pytorch-logo.webp",
              name: "Pytorch",
              home: "https://pytorch.org",
            },
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
            {
              url: "images/framework/detectron2.webp",
              name: " Detectron2",
              home: "https://github.com/facebookresearch/detectron2",
            },
          ],
        },
        {
          name: "poster_candidate_title",
          image: "images/models/poster-banner.webp",
          detail: "poster_candidate_detail",
          feature: "poster_candidate_feature",
          techs: [
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
            {
              url: "images/framework/pytorch-logo.webp",
              name: "Pytorch",
              home: "https://pytorch.org",
            },
            {
              url: "images/framework/ffmpeg.webp",
              name: "FFmpeg",
              home: "https://ffmpeg.org/",
            },
          ],
        },
        {
          name: "branding_title",
          image: "images/models/branding-banner.webp",
          detail: "branding_detail",
          feature: "branding_feature",
          techs: [
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
            {
              url: "images/framework/pytorch-logo.webp",
              name: "Pytorch",
              home: "https://pytorch.org",
            },
            {
              url: "images/framework/ffmpeg.webp",
              name: "FFmpeg",
              home: "https://ffmpeg.org/",
            },
          ],
        },
        {
          name: "color_title",
          image: "images/models/color-banner.webp",
          detail: "color_detail",
          feature: "color_feature",
          techs: [
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
            {
              url: "images/framework/scikit-learn-logo.webp",
              name: "Scikit Learn",
              home: "https://scikit-learn.org/",
            },
            {
              url: "images/framework/ffmpeg.webp",
              name: "FFmpeg",
              home: "https://ffmpeg.org/",
            },
          ],
        },
        {
          name: "age_gender_title",
          image: "images/models/age-gender-banner.webp",
          detail: "age_gender_detail",
          feature: "age_gender_feature",
          techs: [
            {
              url: "images/framework/pytorch-logo.webp",
              name: "Pytorch",
              home: "https://pytorch.org",
            },
            {
              url: "images/framework/opencv-logo.webp",
              name: "OpenCv",
              home: "https://opencv.org/",
            },
            {
              url: "images/framework/dlib_logo.webp",
              name: "Dlib",
              home: "http://dlib.net/",
            },
          ],
        },
      ],
      colors: ["#E8F7F1", "#F0FAFE"],
      iConCheck: mdiCheck,
    };
  },
  computed: {
    isBreakCol() {
      if (
        this.$vuetify.breakpoint.name === "md" ||
        this.$vuetify.breakpoint.name === "sm" ||
        this.$vuetify.breakpoint.name === "xs"
      ) {
        return 1;
      } else return 0;
    },
  },
  mounted() {
    let nav = document.getElementById("nav");
    if (nav) {
      for (let el of nav.children) {
        if (el.id === "tech-specs") {
          el.classList.add("active");
        } else el.classList.remove("active");
      }
    }
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 991px) {
  .detail-model {
    order: 2 !important;
  }
  .image-model {
    order: 1 !important;
  }
}

.logo-framework {
  img {
    height: 45px !important;
    max-width: 120px !important;
    object-fit: scale-down;
    margin-left: 22px !important;
  }
}

.image-model {
  img {
    box-shadow: 0 4px 2px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
}
</style>
